module.exports = __webpack_public_path__ + "media/application/images/external-services/tiktok-logo-31cd9e0234f3170c46d800cdcaf2467d.svg";